// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../node_modules/css-loader/dist/cjs.js??clonedRuleSet-24.use[1]!../../../node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-24.use[2]!../../../node_modules/sass-loader/dist/cjs.js??clonedRuleSet-24.use[3]!../fonts/inter-4.1/inter.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --bg-primary: #ffffff;
  --bg-card: #ffffff;
  --bg-sidebar: rgba(255, 255, 255, 0.8);
  --text-primary: #1a1a1a;
  --text-subtle: #666666;
  --border-color: #e5e7eb;
  --hover-bg: rgba(0, 0, 0, 0.05);
  font-family: "Inter", sans-serif;
  font-feature-settings: "liga" 1, "calt" 1;
  /* fix for Chrome */
  font-synthesis: none;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

@supports (font-variation-settings: normal) {
  :root {
    font-family: "Inter", sans-serif;
  }
}
[data-theme=dark] {
  --bg-primary: #1a1a1a;
  --bg-card: #242424;
  --bg-sidebar: rgba(26, 26, 26, 0.8);
  --text-primary: #ffffff;
  --text-subtle: #a3a3a3;
  --border-color: #404040;
  --hover-bg: rgba(255, 255, 255, 0.05);
}

html {
  scroll-behavior: smooth;
  -webkit-tap-highlight-color: transparent;
  /* Responsive root font size for better readability on mobile */
  font-size: clamp(16px, 1rem, 18px);
}

body {
  background-color: var(--bg-primary);
  color: var(--text-primary);
  /* Comfortable line height for older users */
  line-height: 1.75;
  letter-spacing: 0.025em;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-rendering: optimizeLegibility;
  -webkit-text-size-adjust: 100%;
}

.public-home {
  font-family: "Athiti", ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Noto Color Emoji";
}

nav .router-link-exact-active {
  background-color: #e7e7e7;
}

.home-hero {
  /* background: url('~@/assets/images/home-hero-bg.jpg') no-repeat center center; */
  color: #000000;
  padding: 20px;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.16s ease-in-out;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

@keyframes fade {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
.fade2-enter-active {
  animation: fade 0.16s ease forwards;
}

.fade2-leave-active {
  animation: fade 0.16s ease reverse forwards;
}

.bg-card {
  background-color: var(--bg-card);
}

.text-card-foreground {
  color: #14191d;
}

.bg-background-button {
  background-color: #2c3e50;
}

.bg-background-button-hover {
  background-color: #34495e;
}

.text-subtle {
  color: var(--text-subtle);
}

.bg-white {
  background-color: var(--bg-primary) !important;
}

.hover\\:bg-gray-100:hover {
  background-color: var(--hover-bg) !important;
}

.border-gray-200 {
  border-color: var(--border-color) !important;
}

.animate-spin {
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.animate-hearth {
  animation: pulse 1s infinite;
}

@keyframes pulse {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.1);
  }
  100% {
    transform: scale(1);
  }
}
.text-message {
  font-family: ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Noto Color Emoji";
  font-feature-settings: "rlig" 1, "calt" 1, "ss01" 1, "ss06" 1;
  font-size: 16px;
  color: #131313;
}
.text-message li {
  margin-bottom: 10px;
}
.text-message GenerateImage {
  display: none;
}
.text-message pre {
  white-space: pre-wrap;
  word-wrap: break-word;
  background-color: #f5f5f5;
  margin: 1.6em 0;
  padding: 1em;
  border-radius: 4px;
  font-size: 0.9rem;
  color: #000000;
  border: 1px solid #e1e4e8;
}

@keyframes shimmer {
  0% {
    background-position: -1000px 0;
  }
  100% {
    background-position: 1000px 0;
  }
}
.skeleton {
  animation: shimmer 2s infinite linear;
  background: linear-gradient(to right, rgba(255, 255, 255, 0.1) 4%, rgba(255, 255, 255, 0.2) 25%, rgba(255, 255, 255, 0.1) 36%);
  background-size: 1000px 100%;
  position: relative;
  overflow: hidden;
}

.dark .skeleton {
  background: linear-gradient(to right, rgba(255, 255, 255, 0.05) 4%, rgba(255, 255, 255, 0.1) 25%, rgba(255, 255, 255, 0.05) 36%);
}

.glass {
  background: rgba(255, 255, 255, 0.7);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.18);
}

.dark .glass {
  background: rgba(17, 25, 40, 0.75);
  border: 1px solid rgba(255, 255, 255, 0.125);
}

.transition-all {
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 300ms;
}

.hover-lift {
  transition: transform 0.2s ease;
}
.hover-lift:hover {
  transform: translateY(-2px);
}

.active-link-indicator {
  position: relative;
}
.active-link-indicator::after {
  content: "";
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 4px;
  height: 24px;
  background: #6366f1;
  border-radius: 4px 0 0 4px;
  opacity: 0;
  transition: opacity 0.2s ease;
}
.active-link-indicator.active::after {
  opacity: 1;
}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
